<template>
    <div>        
        <entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" :entity.sync="entity"></entity-card>        
    </div>
</template>

<script>
    import CompanyBranch from "@/models/companyBranch.model.vue";
    import EntityCard from "@/components/Espresso/EntityCard.vue";
    import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
    import { Tabs, Modal } from "@/components";

    export default {
        components: {
            EntityCard,
            PaginatedSearch,
            Tabs,
            Modal
        },
        data() {
            return {
                entity: {
                    id: this.$route.params.companyBranchId,
                    companyId: this.$route.params.id,                    
                },
                schema: CompanyBranch.getSchema(),
                showModal: false,
            }
        },
        methods: {
            async createEntity(entity) {
				this.entity = await CompanyBranch.create(entity);
				this.$router.replace(`/empresa/${this.entity.companyId}/filial/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				const response = await CompanyBranch.getInfo(entityId);
                console.log('readEntity', response);
				return response;
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
                dataToUpdate.companyId = this.entity.companyId;
                console.log('updateEntity', dataToUpdate);
				return CompanyBranch.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await CompanyBranch.remove(entityId);
				//this.$router.push("/empresas");
                this.$router.go(-1);
			},
        },
        mounted() {
            console.log("Branch mounted");
        }
    }

</script>

<style>
.tab-pane-1,
.tab-pane-2 {
  width: 100% !important;
}

.modal-container {
	box-shadow: none !important;
}
</style>